export default "__VITE_ASSET__C_mYhz4i__"